import { render, staticRenderFns } from "./TestColumnModule.vue?vue&type=template&id=1d732b4a&scoped=true&"
import script from "./TestColumnModule.vue?vue&type=script&lang=js&"
export * from "./TestColumnModule.vue?vue&type=script&lang=js&"
import style0 from "./TestColumnModule.vue?vue&type=style&index=0&id=1d732b4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d732b4a",
  null
  
)

export default component.exports